module.exports = __webpack_public_path__ + "media/images/prijava_hover-b50acb28.svg";